$.ActiveDataManager = function(options) {
	var obj = $.extend({
		register: function(settings) {
			this.listeners[settings.tab] = settings;

			if(typeof this.active != 'undefined') {
				this.changeActiveForListener(this.active, settings);
			} else if(settings.loader) {
				$(settings.loader).addClass('active');
			} else if(settings.componentProps) {
				settings.componentProps.projectsLoading = true;
			}
		},
		unregister: function(id) {
			delete this.listeners[id];
			delete this.delayedListeners[id];
		},
		changeActive: function(active) {
			if(active === this.active) {
				return;
			}

			this.active = active;
			if(this.globalAccess) {
				$[this.globalAccess] = active;
			}

			for (var id in this.listeners) {
				var settings = this.listeners[id];
				this.changeActiveForListener(active, settings);
			}
		},
		addToActive: function(newItem) {
			this.active.push(newItem);

			for (var id in this.listeners) {
				var settings = this.listeners[id];

				if(settings.onAddHandler) {
					settings.onAddHandler(newItem);
				} else {
					this.changeActiveForListener(true, settings);
				}
			}
		},
		changeActiveForListener: function(active, settings) {
			var id = settings[this.id];
			if(!this.isListenerActive(settings) || (settings.isListenerActive && !settings.isListenerActive())) {
				if (settings.loader) {
					$(settings.loader).addClass('active');
				} else if(settings.componentProps) {
					settings.componentProps.projectsLoading = true;
				}

				this.delayedListeners[id] = true;
				return;
			} else if(this.delayedListeners[id]) {
				this.delayedListeners[id] = false;
			}

			if(active) {
				if (settings.initialized) {
					if (settings.onReload) {
						settings.onReload(active);
					}
				} else {
					if (settings.onFirstLoad) {
						settings.onFirstLoad(active);
					}
					settings.initialized = true;
				}

				if (settings[this.onChangeHandlerName]) {
					settings[this.onChangeHandlerName](active);
				}
			} else {
				if(settings.onNoActive) {
					settings.onNoActive();
				}
			}

			if (settings.loader) {
				$(settings.loader).removeClass('active');
			} else if(settings.componentProps) {
				settings.componentProps.projectsLoading = false;
			}

			if(this.onChangeActive) {
				this.onChangeActive(active, settings);
			}
		},
		runDelayedListener: function(id) {
			var active = this.delayedListeners[id];
			if(active) {
				this.changeActiveForListener(this.active, this.listeners[id]);
			}
		},
		isListenerActive: function(settings) {
			return true;
		},
		listeners: {},
		delayedListeners: {},

		id: 'id',
		onChangeHandlerName: 'onChangeHandler'
	}, options);

	return obj;
};

$.ActiveTabManager = function(options) {
	var obj = $.ActiveDataManager();
	obj._register = obj.register;

	$.extend(obj, {
		register: function(settings) {
			if($.mainApp) {
				settings.tabVue = $.mainApp.getTabByName(settings.tab);
			} else {
				settings.tabDiv = $('#tabs > .tab[data-tab="' + settings.tab + '"]');

				if(this.noProjectsMessage) {
					settings.noProjectsMessage = $('<div class="ui warning message" style="display: none">').text(this.noProjectsMessage).appendTo(settings.tabDiv);
				}
			}

			this._register(settings);
		},
		onChangeActive: function(active, settings) {
			if(active) {
				if(settings.hiddenContent) {
					settings.hiddenContent.show();
					settings.noProjectsMessage.hide();
					settings.hiddenContent = null;
				}

				if(settings.tabVue) {
					window.Vue.set(settings.tabVue, 'warningMessage', null);
				}
			} else {
				if(this.noProjectsMessage && settings.tabDiv) {
					settings.hiddenContent = settings.tabDiv.children(':not(.ui.header, script)');
					settings.hiddenContent.hide();
					settings.noProjectsMessage.show();
				}

				if(this.noProjectsMessage && settings.tabVue) {
					window.Vue.set(settings.tabVue, 'warningMessage', this.noProjectsMessage);
				}
			}
		},
		isListenerActive: function(settings) {
			if(settings.tab.indexOf('general') !== -1) {
				return !!$.userPermissions;
			} else if($.activeTabPath == settings.tab) {
				return true;
			} else {
				return false;
			}
		},
		updateOnReturn: function(newId, oldId) {
			var settings = this.listeners[newId];
			if(settings && settings.updateOnReturn) {
				this.changeActiveForListener(this.active, settings);

				if(this.listeners[oldId]) {
					delete this.listeners[oldId];
				}
			}
		},
		id: 'tab',
		onChangeHandlerName: 'onSchoolChangeHandler',
		hiddenContent: null
	}, options);

	return obj;
};